import { render, staticRenderFns } from "./SearchPopUp.vue?vue&type=template&id=f4f8d070&scoped=true&"
import script from "./SearchPopUp.vue?vue&type=script&lang=js&"
export * from "./SearchPopUp.vue?vue&type=script&lang=js&"
import style0 from "./SearchPopUp.vue?vue&type=style&index=0&id=f4f8d070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f8d070",
  null
  
)

export default component.exports